import { render, staticRenderFns } from "./UserShortened.vue?vue&type=template&id=67fae1fc&scoped=true&"
import script from "./UserShortened.vue?vue&type=script&lang=js&"
export * from "./UserShortened.vue?vue&type=script&lang=js&"
import style0 from "./UserShortened.vue?vue&type=style&index=0&id=67fae1fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fae1fc",
  null
  
)

export default component.exports